import { WalletAddress } from '@btcdirect/stores';

export function isVerified(wallet: WalletAddress): boolean {
    return !!wallet && (!wallet.status || wallet.status === 'verified');
}

export function needsVerification(wallet: WalletAddress): boolean {
    return !!wallet && !!wallet.status && ['open', 'rejected'].includes(wallet.status);
}
